import { render, staticRenderFns } from "./comms.vue?vue&type=template&id=2d6fec17&scoped=true"
import script from "./comms.vue?vue&type=script&lang=ts"
export * from "./comms.vue?vue&type=script&lang=ts"
import style0 from "./comms.vue?vue&type=style&index=0&id=2d6fec17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6fec17",
  null
  
)

export default component.exports